import './manageDicts.scss'
import DatepickerField from "../../../../components/datepickerField/datepickerField";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import FormField from "../../../../components/formField/formField";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import { DatepickerFieldProps } from "../../../../components/datepickerField/types/datepickerFieldProps";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { apiContext } from "../../../../contexts/apiContext";
import { getDictionaryForEditing } from "../../../../helpers/dictionariesFromLayers";
import { AddEditDictProps, MutableDict } from "./types/manageDictsProps";
import { Option, SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import { useContext, useEffect, useState } from "react";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';

const AddDict = (props: AddEditDictProps) => { 
    const api = useContext(apiContext); 
    const [criterionDictOptions, setCriterionDictOptions] = useState<Option[]>([]); 

    const dictsWithCustomFields = ["DICT_KRYT_WYZN_TZ_SZCZEGOLOWE"]
    
    // Custom dicts selects
    useEffect(() => { 
        if (dictsWithCustomFields.includes(props.dictDefinition[0])) {
            getCustomDictionaries();               
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCustomDictionaries = () => {
        switch (props.dictDefinition[0]) 
        {
            case "DICT_KRYT_WYZN_TZ_SZCZEGOLOWE":
                var layer = api.featureServices.dictionariesForEditing.find(item => item[0] === "DICT_KRYT_WYZN_TZ_GLOWNE");
                getDictionary(layer![1], setCriterionDictOptions);
                break;
        }       
    }

    const getDictionary = (layerId: string, setVariable: any) => {
        props.setLoading(true);
        props.setDisableSaveBtn(true);
        props.setDisableDeleteBtn(true);

        getDictionaryForEditing(api.featureServices.dictionariesForEditingBaseUrl + layerId)
        .then((res: any) => {
            prepareDictOptions(res, setVariable);
            props.setLoading(false);
        })
    }

    const prepareDictOptions = (data: MutableDict[], setVariable: any) => {
        var dictOptions: Option[] = [];
        data.sort((a, b) => a.KOLEJNOSC! - b.KOLEJNOSC!);
        data.forEach(item => {
            var dictOption: Option = { name: item.WARTOSC, value: item.ID};
            dictOptions.push(dictOption);
        })
        setVariable(dictOptions);
    }

    // Save button disable toggle
    useEffect(() => { 
        props.setDisableSaveBtn(props.editedDictRecord === undefined || props.editedDictRecord.WARTOSC === undefined || props.editedDictRecord.WARTOSC === "")

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.editedDictRecord])
    
    // Inputs
    const onChangeInput = (event: string, id: string) => {
        props.setEditedDictRecord((prevData: any) => ({...prevData, [id]: event}))
    }

    const getInputProps =(label: string, placeholder: string, value: any, type: string, inputId: string): FormFieldProps => {
        return {
            labelName: label,
            inputPlaceholder: placeholder,
            value: value,
            type: type,
            pristine: true,
            keepPristine: true,
            setValue: (event: any) => onChangeInput(event, inputId),
        }
    }

    // Datepicker
    const onChangeDate = (event: Date, id: string) => {
        props.setEditedDictRecord((prevData: any) => ({...prevData, [id]: event ? event.getTime() : null}));
    }

    const datepickerFieldPropsValidityDate = (label: string, inputPlaceholder: string, value: any, inputId: string): DatepickerFieldProps => {
        return {
            dateFormat: "yyyy-MM-dd",
            selected: value,
            shouldCloseOnSelect: false,
            fixedHeight: true,
            inputPlaceholder: inputPlaceholder,        
            labelName: label,
            additionalIcon: eventIcon,
            setValue: (event: any) => onChangeDate(event, inputId),
            pristine: true,
            keepPristine: true
        }
    }

    // Custom fields
    const detailedCriterionSelectProps: SelectInputProps = {
        label: "Główne kryterium wyznaczenia terenu",
        hasInputTags: true,
        options: criterionDictOptions,
        onlySingleTag: true,
        onChange: (event:any) => onChangeSelectCustomCriterion(event, "KRYT_WYZN_TZ_GLOWNE_ID"),
        pristine: true,
        className: "selectDictRecord",
        style: styleFormFieldHalf,
    }

    const renderCustomFields = () => {
        switch (props.dictDefinition[0]) 
        {
            case "DICT_KRYT_WYZN_TZ_SZCZEGOLOWE":
                return (
                    <div style={{ paddingTop: "30px"}}>
                        <SelectInput {...detailedCriterionSelectProps}/>
                    </div>
                )
        }
    }

    const onChangeSelectCustomCriterion = (opt: Option[], id: string) => {
        if (opt.length > 0) {
            props.setEditedDictRecord((prevData: any) => ({...prevData, [id]: opt[0].value}))
        }
        else {
            props.setEditedDictRecord((prevData: any) => ({...prevData, [id]: undefined}))
        }        
    }
    
    return (
        <div className="editDictWrapper">
            <div className="editDictDetailsInputs">
                <div>
                    <FormField {...getInputProps(
                        "Wartość",
                        "Wpisz wartość pozycji słownikowej",
                        props.editedDictRecord ? props.editedDictRecord.WARTOSC : undefined,
                        "text",
                        "WARTOSC"
                    )}/>
                    <FormField {...getInputProps(
                        "Wartość ENG",
                        "Wpisz wartość ENG pozycji słownikowej",
                        props.editedDictRecord ? props.editedDictRecord.WARTOSC_EN : undefined,
                        "text",
                        "WARTOSC_EN"
                    )}/>
                </div>
                <div>
                    <DatepickerField {...datepickerFieldPropsValidityDate(
                        "Ważna od",
                        "Wybierz początek obowiązywania pozycji słownikowej",
                        props.editedDictRecord ? props.editedDictRecord.WAZNY_OD : undefined, 
                        "WAZNY_OD")}/>
                    
                </div>               
            </div>  
            {renderCustomFields()}        
        </div>
    );
}

export default AddDict;